import { create } from "zustand";

export const ZustandStore = create((set) => ({
  isSidebarOpen: false,
  setSidebarOpen: (value) => set({ isSidebarOpen: value }),
  isAdminPerformAction: {
    email: "",
    isAdmin: false,
    isPerformAction: false,
  },
  user_profile: [],
  customer_plan: [],

  selected_domain: "",
  site_overview_data: [],
  backlink_data_hm: [],
  domain_auth_hm: [],
  site_audit_hm: [],
  site_audit_data: [],
  site_audit_domain: "",
  site_audit_overview: [],
  emptySiteAuditData: () => {
    set(() => ({
      site_audit_data: [],
      site_audit_domain: "",
      site_audit_overview: [],
    }));
  },
  plan_loaded: false,

  // rank tracking
  rank_Chart_data: [],
  all_loc_data: [],
  keyword_latest_data: [],
  keyword_old_data: [],
  keyword_loc_data: "",
  emptyAllLocData: () => {
    set(() => ({
      all_loc_data: [],
    }));
  },
  emptyKeywordData: () => {
    set(() => ({
      keyword_old_data: [],
      keyword_latest_data: [],
    }));
  },
  rank_keyword: [],
  average_rank: null,
  keyword_move_up: null,
  keyword_move_down: null,
  active_tab_rank: "",
  improved: [],
  declined: [],
  alert: {
    show: false,
    msg: null,
    error: false,
  },
  gap_analyser_data: [],
  // country:
  country_Data: { data: [], error: false, loading: true },
  // country&languages:
  country_Language_Data: { data: [], error: false, loading: true },
  // backlink page data
  get_link_feature: [],
  backlink_analysis: { data: [], type: "" },
  get_domain_authority: 0,
  referring_domain: [],
  guest_post_data: {
    loading: true,
    error: false,
    data: [],
  },
  // keyword research page data
  keyword_research_ideas_data: {
    data: [],
    loading: false,
    search: false,
  },
  keyword_research_data: {
    data: [],
    search: false,
    error: false,
    loading: false,
  },
  keyword_ques_based_data: {
    data: [],
    search: false,
    loading: false,
  },
  // site overview page data
  site_overview_page_data: [],
  site_overview_backlink_data: [],
  worldwide_domain: null,
  sel_worldwide_country: null,
  site_overview_worldwide: {
    domain: "",
    data: [],
  },
  //view-List
  view_list: {
    data: [],
    loading: true,
  },
  // keyword-tag
  keyword_tag_data: {
    loaded: false,
    error: false,
    data: [],
  },
  // filter-tag
  filter_tag: [],
  tag_keywords: [],
  emptyTagData: () => {
    set(() => ({
      tag_keywords: [],
      filter_tag: [],
      keyword_tag_data: {
        loaded: false,
        error: false,
        data: [],
      },
    }));
  },
  updateTag: (tag_name) =>
    set((state) => {
      const itemExists = state.filter_tag.includes(tag_name);
      return {
        filter_tag: itemExists
          ? state.filter_tag.filter((item) => item !== tag_name)
          : [...state.filter_tag, tag_name],
      };
    }),
  // google property name
  property_name: [],
  google_console_data: [],
  // project section
  project_section: {
    data: [],
    error: false,
    loading: true,
  },

  history_data: {
    data: [],
    error: true,
    loading: true,
  },

  userAccessData: [],
  // date-rank-data
  selected_date: null,
  selected_rank_data: {
    data: [],
    loaded: false,
  },
  


  // map-tracker dialog
  show_project_dialog: false,

  // map-tracker data
  mapshowloader: false,
  mapkeywordlimit: 10,
  mapProjectlimit: 2,
  mapcompetitorslimit: 2,
  map_rank_group: [],
  mapactive_tab_rank: "",
  map_date: { title: "days", day: 30, meta_des: "30" },
  map_top_rank: {
    data: [],
    top_rank: false,
    type: "",
    competitors: false,
  },
  ISPROJECT: false,
  bussiness_name: null,
  mapdeviceType: null,
  CURRLOCATION: {
    code: null,
    name: null,
  },
  map_deviceType: null,
  map_project: [],
  map_all_loc_data: [],
  map_keyword_latest_data: [],
  map_keyword_old_data: [],
  map_keyword_loc_data: "",

  selected_project_id: null,
  RANKMOVEDUP: 0,
  RANKMOVEDDOWN: 0,
  USERALLPENDINGRESULT: [],
  USERALLKEYWORDRESULT: [],
  RANKKEYWORD: [],
  SELECTEDPROJECTNEWDATA: [],
  USERCOMPATITORS: [],
  PREVIOUSALLOLDDATA: [],
  OLDKEYWORDDATA: [],
  USERCURRENTPROJECTLOCATION: [],

  //show tracker dialg
  ShowDialogTracker: false,

  // Ai Limits
  aiLimit: {
    id: null,
    email: null,
    limit: 0,
    article: 0,
    meta: 0,
  },
  // dynamic-table
  // project section table
  projectTable: [],
  updateProjectTableCol: (column) =>
    set((state) => {
      const itemExists = state.projectTable.includes(column);
      return {
        projectTable: itemExists
          ? state.projectTable.filter((item) => item !== column)
          : [...state.projectTable, column],
      };
    }),

  // rank-table section table
  competitorTableColumn: [],
  updateCompetitorTableCol: (column) =>
    set((state) => {
      const itemExists = state.competitorTableColumn.includes(column);
      return {
        competitorTableColumn: itemExists
          ? state.Column.filter((item) => item !== column)
          : [...state.competitorTableColumn, column],
      };
    }),

  mapCompetitorTableColumn: [],
  updateMapCompetitorTableCol: (column) =>
    set((state) => {
      const itemExists = state.mapCompetitorTableColumn.includes(column);
      return {
        mapCompetitorTableColumn: itemExists
          ? state.mapCompetitorTableColumn.filter((item) => item !== column)
          : [...state.mapCompetitorTableColumn, column],
      };
    }),

  rankTableColumn: [],
  updateRankTableCol: (column) =>
    set((state) => {
      const itemExists = state.rankTableColumn.includes(column);
      return {
        rankTableColumn: itemExists
          ? state.rankTableColumn.filter((item) => item !== column)
          : [...state.rankTableColumn, column],
      };
    }),

  mapRankTableColumn: [],
  updateMapRankTableCol: (column) =>
    set((state) => {
      const itemExists = state.mapRankTableColumn.includes(column);
      return {
        mapRankTableColumn: itemExists
          ? state.mapRankTableColumn.filter((item) => item !== column)
          : [...state.mapRankTableColumn, column],
      };
    }),

  // keyword section table
  KeywordTableColumn: [],
  updateKeywordTableColumn: (column) =>
    set((state) => {
      const itemExists = state.KeywordTableColumn.includes(column);
      return {
        KeywordTableColumn: itemExists
          ? state.KeywordTableColumn.filter((item) => item !== column)
          : [...state.KeywordTableColumn, column],
      };
    }),
  //backlink refdomain
  backlinkTableColumn: [],
  updateBacklinkTableColumn: (domain) =>
    set((state) => {
      const itemExists = state.backlinkTableColumn.includes(domain);
      return {
        backlinkTableColumn: itemExists
          ? state.backlinkTableColumn.filter((item) => item !== domain)
          : [...state.backlinkTableColumn, domain],
      };
    }),

  backlinkRefDomainColumn: [],
  updateBacklinkRefDomainTableColumn: (domain) =>
    set((state) => {
      const itemExists = state.backlinkRefDomainColumn.includes(domain);
      return {
        backlinkRefDomainColumn: itemExists
          ? state.backlinkRefDomainColumn.filter((item) => item !== domain)
          : [...state.backlinkRefDomainColumn, domain],
      };
    }),
}));
